import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'BUCKY AI',
    description: 'An AI promoter that turns attention into action. Meet Bucky AI — a new approach to engaging customers and promoting physical businesses.',
    url: 'https://bucky-ai.modulify.website'
}
